import { useEffect } from "react";
import { Navigation } from "../../components/Navigation/navigation";
import './technology.css';
export const Technology = ( props ) => {
    useEffect(()=>{
        document.querySelector("body#ruby-rock-app").scrollTop = 0;
    },[])
    return (
        <>
        <Navigation />
        <div id="technology" className='text-center'>
            <div className='container'>
                <div className='section-title'>
                    <h2>Technology & Security</h2>
                    <div className="tech-text">
                        <p>RubyRock is built on Ethereum, the leading smart-contracts platform in terms of transaction finality and network liveliness, leveraging its most well-known standards, which enables composability across its ecosystem, namely:</p>
                        <ul>
                            <li><strong>ERC721:</strong> de facto standard for non-fungible tokens, applied in this case to signal physical ownership over a property</li>
                            <li><strong>ERC20:</strong> de-facto standard for cryptocurrencies in Ethereum based blockchains, also known as tokens.</li>
                            <li><strong>EIP2325 & EIP1967:</strong> State-of-the-art approach that enables the protocol to evolve according to the needs of the current market.</li>
                            <li><strong>Multisignature ownership:</strong> safe-guards against hacks to individuals and their private keys that could compromise the project.</li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
        </>
    )
}